var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPacketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F1F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8234 14.9999V9.08976L14.9371 7.83228V13.6886L10.8234 14.9999Z",
    fill: "#649EE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79341 8.67647L10.2485 9.14354L10.2036 14.9908L6 13.7154V7.76929L7.99401 8.41599V9.29623C8.05988 9.24534 8.2024 9.15971 8.24551 9.22438C8.28862 9.28905 8.40719 9.35312 8.46108 9.37707C8.58323 9.31959 8.73353 9.40102 8.79341 9.44893V8.67647Z",
    fill: "#649EE3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0958 6.80835C13.0095 6.80835 10.2036 7.64068 8.81134 8.05685L10.5 8.56883L14.6586 7.29338C14.1736 7.1317 13.182 6.80835 13.0958 6.80835Z",
    fill: "#649EE3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27844 7.32036L7.94012 7.78743L12.1437 6.53892L10.491 6L6.27844 7.32036Z",
    fill: "#649EE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacketIcon);
export default __webpack_public_path__ + "static/media/packetIcon.c0b57b8389e62d15c5ac54f13a739f43.svg";
export { ForwardRef as ReactComponent };